<div class='row p-2'>

  <div *ngIf="!workingMode" class='col'>
    <button class='btn btn-success btn-sm ml-0' (click)="emitAction('new')">
      <i class='fas fa-plus'></i>
      Neu
    </button>

    <button class="btn btn-primary btn-sm ml-2" (click)="emitAction('edit')">
      <i class='fas fa-edit'></i>
      Ändern
    </button>

    <button class="btn btn-danger btn-sm ml-2" (click)="emitAction('delete')">
      <i class='fas fa-trash'></i>
      Löschen
    </button>

  </div>

  <div *ngIf="workingMode" class='col'>

    <button class='btn btn-success btn-sm ml-0' (click)="emitAction('submit')">
      <i class='fas fa-save'></i>
      Übernehmen
    </button>

    <button class="btn btn-dark btn-sm ml-2" (click)="emitAction('cancel')">
      <i class='fas fa-times'></i>
      Verwerfen
    </button>

  </div>

</div>